module.exports = __webpack_public_path__ + "static/media/video-cameraab641831.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/galleryUploadIcons/video-camera.svg
// module id = 1244
// module chunks = 0